import React from 'react';

import { useSessionData } from '../../../../../public-src/core/js/schibsted-account/react.server.js';
import { NotLoggedIn } from './NotLoggedIn.js';
import { LoggedIn } from './LoggedIn.js';
import {
  NEWSLETTERS_HOME_URL,
  NEWSLETTER_SERIETIPS,
  NEWSLETTER_VINK,
  NEWSLETTER_VINK_MED_BARN,
  newsletterMappings,
} from './consts.js';
import useIsUserAlreadySubscribed from '../../hooks/useNewsletterUserStatus.js';
import { useShouldHideDueToViews } from '../../hooks/useShouldHideNewsletterDueToViews.js';

export const Newsletter: React.FC<{ isMovieReview?: boolean }> = ({
  isMovieReview,
}) => {
  const session = useSessionData();

  const primary = isMovieReview ? NEWSLETTER_SERIETIPS : NEWSLETTER_VINK;
  const secondary = NEWSLETTER_VINK_MED_BARN;

  const isSubscribedToPrimary = useIsUserAlreadySubscribed({
    newsletterId: primary,
    newsletterPublication: 'aftenposten',
    session,
  }).isAlreadySubscribed;

  const isSubscribedToSecondary = useIsUserAlreadySubscribed({
    newsletterId: secondary,
    newsletterPublication: 'aftenposten',
    session,
  }).isAlreadySubscribed;

  const newsletterId = isSubscribedToPrimary ? secondary : primary;
  const info = newsletterMappings[newsletterId];

  const props = {
    newsletterId,
    location: NEWSLETTERS_HOME_URL,
    ...info,
  };
  const canSubscribe = !!(session && info.access === 'open'); //TODO: If closed, check if user has product.
  const accountReady = session !== null;

  const { shouldHide, newsletterRef } = useShouldHideDueToViews(
    newsletterId,
    canSubscribe,
    accountReady,
  );

  // if the user has seen the widget enough times or is subscribed to both, hide the widget
  if (shouldHide || (isSubscribedToPrimary && isSubscribedToSecondary)) {
    return null;
  }

  return (
    <div className="newsletter" ref={newsletterRef}>
      {session ? (
        <LoggedIn {...props} session={session.user} />
      ) : (
        <NotLoggedIn {...props} />
      )}
    </div>
  );
};
